/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';
import { makeStyles, createStyles, Box, Typography, Container } from '@material-ui/core';
import cn from 'classnames';
import { useHistory } from 'react-router';
import { ArchiveIcon } from '../../assets/icons/ArchiveIcon';
import { LinkIcon } from '../../assets/icons/LinkIcon';
import { LockIcon } from '../../assets/icons/LockIcon';
import Btn from '../../components/Btn/Btn';
import RenderText from '../../dictionaries/RenderText';
import { TranquiTheme } from '../App/theme';
import { IdentificationConfirmationStyles } from './IdentificationConfirmationStyles';
import { useSpace } from '../../content/utils/useSpace';
import { useRepeatableSpace } from '../../content/utils/useRepeatableSpace';

export interface IdentificactionConfirmationInitialPageProps {
  baseClasses: IdentificationConfirmationStyles;
  parentUrl: string;
}

const ICONS: Record<string, React.ReactElement> = {
  archive: <ArchiveIcon />,
  link: <LinkIcon />,
  lock: <LockIcon />,
};

export const IdentificactionConfirmationInitialPage:
React.FC<IdentificactionConfirmationInitialPageProps> = ({ baseClasses, parentUrl }) => {
  const history = useHistory();
  const classes = useStyles();

  // space implementation
  const titleSpace = useSpace('ID_VALIDATION_WELCOME', 'title', {});
  const repeatableSpace = useRepeatableSpace('ID_VALIDATION_WELCOME', 'rows', {});

  return (
    <Container className={classes.box}>
      <Typography className={cn(baseClasses.title, 'mb-4', 'mt-2')}>
        {titleSpace.text}
      </Typography>
      {repeatableSpace.rows.map((row) => {
        const [ icon, label, description ] = row.getMany([ 'icon', 'label', 'description' ]);
        return (
          <Box className={classes.reminderWrapper} key={row.key}>
            <Box className="icon">{ICONS[icon?.text || '']}</Box>
            <Box>
              <Typography variant="h3" className={baseClasses.bodyTitle}>
                {label?.text}
              </Typography>
              <Typography className={baseClasses.description}>
                {description?.text}
              </Typography>
            </Box>
          </Box>
        );
      })}
      <Btn
        variant="contained"
        color="primary"
        className={classes.btnContinue}
        data-testid="welcome__next-button"
        onClick={() => history.push(`${parentUrl}/ingresar`)}
      >
        <RenderText textKey="validation_tc_next_button" />
      </Btn>
    </Container>
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  box: {
    padding: theme.spacing(2),
    height: '100%',
    '& .icon': {
      backgroundColor: theme.palette.pearl.main,
      boxShadow: theme.shadows[1],
      minWidth: '75px',
      height: '75px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: theme.shape.borderRadius,
      marginRight: theme.spacing(2),
    },
  },
  reminderWrapper: {
    display: 'flex',
    marginBottom: theme.spacing(2),
  },
  btnContinue: {
    display: 'flex',
    margin: theme.spacing(4, 0, 0),
    marginLeft: 'auto',
  },
}));

IdentificactionConfirmationInitialPage.displayName = 'IdentificactionConfirmationInitialPage';
